// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-picker-wrapper {
  position: relative;
}

.time-input {
  border: 1px solid #d5d7db;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.clock-icon {
  margin-left: 10px;
}

.timeDropdown {
  position: absolute;
  left: 0;
  background: #f3f3f3;
  border-radius: 8px;
  display: flex;
  padding: 10px;
  gap: 10px;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

/* Open Below */
.timeDropdown.bottom {
  top: 110%;
}

/* Open Above */
.timeDropdown.top {
  bottom: 110%;
}

.timeColumn {
  height: 200px;
  overflow-y: auto;
  width: 60px;
  text-align: center;
}

.item {
  padding: 8px 0;
  cursor: pointer;
  border-radius: 4px;
}

.item:hover {
  background: #ddd;
}

.item.active {
  background: #0860e6;
  color: white;
}

/* ── Dark theme ── */
.dark .time-input {
  border-color: #334155;
  background: #1e293b;
  color: #f1f5f9;
}

.dark .timeDropdown {
  background: #1e293b;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
}

.dark .item {
  color: #f1f5f9;
}

.dark .item:hover {
  background: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/PosCustomTimeSelector/PosCustomTimeSelector.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,SAAS;EACT,WAAW;EACX,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,SAAS;AACX;;AAEA,eAAe;AACf;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".time-picker-wrapper {\n  position: relative;\n}\n\n.time-input {\n  border: 1px solid #d5d7db;\n  padding: 10px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.clock-icon {\n  margin-left: 10px;\n}\n\n.timeDropdown {\n  position: absolute;\n  left: 0;\n  background: #f3f3f3;\n  border-radius: 8px;\n  display: flex;\n  padding: 10px;\n  gap: 10px;\n  z-index: 10;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Open Below */\n.timeDropdown.bottom {\n  top: 110%;\n}\n\n/* Open Above */\n.timeDropdown.top {\n  bottom: 110%;\n}\n\n.timeColumn {\n  height: 200px;\n  overflow-y: auto;\n  width: 60px;\n  text-align: center;\n}\n\n.item {\n  padding: 8px 0;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.item:hover {\n  background: #ddd;\n}\n\n.item.active {\n  background: #0860e6;\n  color: white;\n}\n\n/* ── Dark theme ── */\n.dark .time-input {\n  border-color: #334155;\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .timeDropdown {\n  background: #1e293b;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);\n}\n\n.dark .item {\n  color: #f1f5f9;\n}\n\n.dark .item:hover {\n  background: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
